import { useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import i18n from "./i18n"; // <- مهم: استورد instance المهيأ من ملف i18n الخاص بمشروعك

// Components
import Index from "./jsx";
import LoadingScreen from "./jsx/components/loading-screen/LoadingScreen";

// Redux Actions
import { checkAutoLogin } from "./services/AuthService";
import { getHomeDataFunc } from "./store/custom-actions/settings-actions/dahsboard/GetHomeDataSlicer";
import { getLanguageSettingsFunc } from "./store/custom-actions/language/GetLanguageSettingsSlicer";
import { SettingsProvider } from "./context/SettingsContext";

// Style

import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import "react-toastify/dist/ReactToastify.css";
import { ThemeContext } from "./context/ThemeContext";

const App = (props) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  const homeDataApi = `${process.env.REACT_APP_VERSEL_API}/api/dashboard/global-settings`;

  const { data: homeData } = useSelector((state) => state.getHomeDataSlicer);
  const { data: languageData, loading: languageLoading } = useSelector(
    (state) => state.getLanguageSettingsSlicer
  );

  // Load Home Data
  useEffect(() => {
    if (token) {
      dispatch(getHomeDataFunc(homeDataApi));
    }
  }, [token, dispatch, homeDataApi]);

  // Auto login check
  useEffect(() => {
    checkAutoLogin(dispatch, props.history);
  }, [dispatch, props.history]);

  // Load language based on saved langSlug or default
  useEffect(() => {
    const slug = localStorage.getItem("langSlug");
    const langUrl = slug ? `?lang=${slug}` : "";
    dispatch(getLanguageSettingsFunc(langUrl));
  }, [dispatch]);

  const { changeDirectionLayout } = useContext(ThemeContext);
  // When language data arrives
  useEffect(() => {
    if (!languageData?.defaultLang || !languageData?.all_word) return;
    const { direction: langDirection, slug } = languageData.defaultLang;

    // update direction once
    if (typeof changeDirectionLayout === "function") {
      changeDirectionLayout({
        value: langDirection,
        label: langDirection.toUpperCase(),
      });
    }

    // normalize translations
    let translations = languageData.all_word;
    if (typeof translations === "string") {
      try {
        translations = JSON.parse(translations);
      } catch (e) {
        console.error("Failed to parse all_word JSON:", e);
        translations = {};
      }
    }

    if (!translations || typeof translations !== "object") return;

    try {
      // clear old bundle and add new one
      if (i18n.hasResourceBundle(slug, "translation")) {
        i18n.removeResourceBundle(slug, "translation");
      }

      i18n.addResourceBundle(slug, "translation", translations, true, true);

      // save slug
      localStorage.setItem("langSlug", slug);

      // change language
      if (i18n.language !== slug) {
        i18n.changeLanguage(slug);
      }
    } catch (err) {
      console.error("i18n update error:", err);
    }
  }, [languageData]);

  return (
    <SettingsProvider>
      <Index />
      <ToastContainer className="custom-toast-container" />
      <LoadingScreen loading={languageLoading} />
    </SettingsProvider>
  );
};

export default App;
